// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3yidV","rootCenter":"LoadMoreObserver_rootCenter__Av3fl","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1KQYl"};